import { useEffect, useMemo, useState } from 'react';
import { getContestLeaderboard } from '../../../auth/_requests';
import {
  formatWinnerReward,
  previousMonthDropLabel,
  toInitials,
} from '../utils/prizeDrawUtils';
import { PDR_AVATAR_COLORS } from '../prizeDrawConstants';

export type PrizeDrawWinner = {
  id: string;
  name: string;
  location: string;
  prize: string;
  subtitle: string;
  avatar: string;
  color: string;
  textColor: string;
};

export const usePrizeDrawPastWinners = (token?: string) => {
  const [loading, setLoading] = useState(false);
  const [winners, setWinners] = useState<PrizeDrawWinner[]>([]);
  const dropLabel = useMemo(() => previousMonthDropLabel(), []);

  useEffect(() => {
    const loadPastWinners = async () => {
      if (!token) return;
      setLoading(true);
      try {
        const response = await getContestLeaderboard(token, {
          limit: 20,
          includeOnlyLatestContest: false,
        });

        const mapped = (response?.data ?? []).map((row, index) => {
          const rawName = row.firstName?.trim();
          const displayName = rawName
            ? rawName.toLowerCase().includes('anonymous')
              ? 'Anonymous Member'
              : rawName
            : 'Anonymous member';
          const initials = displayName.toLowerCase().includes('anonymous')
            ? 'A'
            : toInitials(displayName);
          const avBg = PDR_AVATAR_COLORS[index % PDR_AVATAR_COLORS.length];
          const avColor = avBg === '#1e293b' ? '#94a3b8' : '#fff';

          return {
            id: row.contestWinnerId,
            name: displayName,
            location: row.address || 'Canada',
            prize: formatWinnerReward(row),
            subtitle: index === 0 ? dropLabel : 'Recent drop',
            avatar: initials,
            color: avBg,
            textColor: avColor,
          };
        });
        setWinners(mapped);
      } catch (error) {
        console.error('Error fetching rent drop past winners:', error);
        setWinners([]);
      } finally {
        setLoading(false);
      }
    };

    loadPastWinners();
  }, [token, dropLabel]);

  return { winners, loading, dropLabel };
};
